import { Route, AppId, createPageRoute } from '@lumapps/router';

export const administratorsRoute: Route = createPageRoute({
    slug: 'site/administrators',
    id: 'instance-admin',
    appId: AppId.backOffice,
});
